import React, { useState, useEffect } from "react";
import { string, func, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import { Bookmark, BookmarkActive } from "../../atoms/icons/StoryPageIcons";

import { createBookmark, deleteBookmarkByPageId } from "../../helper/api";
import { setBookmark } from "../../helper/actions";

import "./bookmarkViewIcon.m.css";

const BookmarkViewIcon = ({ story, bookmark, setBookmark, metypeConfig, color1, color2, jwtToken }) => {
  const [isBookmarkClicked, setIsBookmarkClicked] = useState(false);

  useEffect(() => {
    if (isBookmarkClicked) {
      // call bookmark func
      setBookmark({});
      callBookmarkApi();
    }
  }, [isBookmarkClicked]);

  const onBookmarkClick = () => {
    if (!isBookmarkClicked) {
      setIsBookmarkClicked(true);
    }
  };

  const callBookmarkApi = () => {
    const storyObj = {
      alternative: story.alternative || {},
      authors: story.authors || [],
      tags: story.tags || [],
      headline: story.headline,
      "hero-image-metadata": story["hero-image-metadata"],
      "hero-image-s3-key": story["hero-image-s3-key"],
      "last-published-at": story["last-published-at"],
      "published-at": story["published-at"],
      metadata: story.metadata || {},
      slug: story.slug,
      id: story.id,
      url: story.url,
      "story-template": story["story-template"],
      subheadline: story.subheadline || ""
    };

    if (story["author-id"]) {
      storyObj["author-id"] = story["author-id"];
    }
    if (story["author-name"]) {
      storyObj["author-name"] = story["author-name"];
    }

    const requestObj = {
      data: {
        type: "bookmark",
        attributes: [
          {
            metadata: storyObj,
            page_id: window.btoa(unescape(encodeURI(encodeURI(story.url)))),
            read_at: new Date().toISOString().split("T")[0] // In yyyy-mm-dd format
          }
        ]
      }
    };

    createBookmark(metypeConfig, requestObj, jwtToken)
      .then(data => setBookmark(data))
      .catch(err => {
        console.log(err);
        setBookmark(null);
      })
      .finally(() => {
        setIsBookmarkClicked(false);
      });
  };

  const onRemoveBookmarkClick = () => {
    deleteBookmarkByPageId(metypeConfig, story.url, jwtToken)
      .then(() => setBookmark(null))
      .catch(err => {
        console.log(err);
      });
  };

  // Story Bookmarked
  if (bookmark) {
    return (
      <div styleName="bookmark-view-icon" onClick={onRemoveBookmarkClick}>
        <BookmarkActive />
      </div>
    );
  }

  return (
    <div styleName="bookmark-view-icon" onClick={onBookmarkClick}>
      <Bookmark color1={color1} color2={color2} />
    </div>
  );
};

BookmarkViewIcon.propTypes = {
  setBookmark: func,
  color1: string,
  color2: string,
  story: object.isRequired,
  bookmark: object,
  jwtToken: string,
  metypeConfig: object
};

const mapStateToProps = state => {
  return {
    bookmark: get(state, ["userReducer", "bookmark"], null),
    jwtToken: get(state, ["userReducer", "jwt_token"], null),
    metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  setBookmark: bookmarkObj => dispatch(setBookmark(bookmarkObj))
});

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkViewIcon);
